import React from 'react';
import styles from './ErrorComponent.module.css';
import ErrorText from '../ErrorText';

// Use memo to prevent unnecessary rerenders when parent components rerender
export const ErrorComponent = React.memo(() => {
  return(
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.errorContainer}>
          <ErrorText reason="No branches assigned to user" />
        </div>
      </div>
    </div>
  );
});

// Add a display name for better debugging
ErrorComponent.displayName = 'ErrorComponent';